import * as THREE from 'three';

export class rectangle {
    public min: THREE.Vector2;
    public max: THREE.Vector2;

    constructor(p1: THREE.Vector2, p2: THREE.Vector2) {
        this.min = p1.clone().min(p2);
        this.max = p1.clone().max(p2);
    }
}
